var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticIconRevenue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0Z",
    fill: "#4AD991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.377 12.2888C13.377 21.3095 20.6897 28.6222 29.7103 28.6222C30.3117 28.6222 30.7992 29.1097 30.7992 29.7111C30.7992 30.3124 30.3117 30.8 29.7103 30.8H12.2881C11.6867 30.8 11.1992 30.3124 11.1992 29.7111V12.2888C11.1992 11.6875 11.6867 11.2 12.2881 11.2C12.8895 11.2 13.377 11.6875 13.377 12.2888Z",
    fill: "#008B45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.438 23.9224C17.0267 24.3612 16.3376 24.3834 15.8988 23.9721C15.4601 23.5608 15.4379 22.8717 15.8492 22.433L19.9325 18.0774C20.3303 17.6531 20.9913 17.6163 21.4337 17.9938C23.1934 19.4954 25.8484 19.2343 27.2818 17.4186L28.8556 15.4252C29.2282 14.9532 29.913 14.8726 30.385 15.2453C30.857 15.6179 30.9375 16.3026 30.5649 16.7746L25.6649 22.9813C25.2822 23.4661 24.5733 23.5358 24.1034 23.1349C22.2605 21.5622 19.507 21.7155 17.8499 23.483L17.438 23.9224Z",
    fill: "#008B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticIconRevenue);
export default __webpack_public_path__ + "static/media/statistic_icon_revenue.32ec40b9fcd627b5ec353e5bf444331e.svg";
export { ForwardRef as ReactComponent };